import { render, staticRenderFns } from "./handlerDashBoard.vue?vue&type=template&id=350a7c2e&"
import script from "./handlerDashBoard.vue?vue&type=script&lang=js&"
export * from "./handlerDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports